import type { JSX } from 'react'

export const UnNotifyIcon = (): JSX.Element => (
  <use href='#unNotifyIcon' height='100%' width='100%' />
)
